import { createFileRoute } from "@tanstack/react-router";
import AdminIPUniversityDetail from "@/pages/AdminIPUniversityDetail";
import RoleGate from "@/components/auth/RoleGate";

export const Route = createFileRoute("/admin/ip-library/university/$slug/")({
  component: () => (
    <RoleGate allow={['staff']} area="IP Library"><AdminIPUniversityDetail /></RoleGate>
  ),
});
